import CommonStyleBasedLegendByKey from '../../../../common/maps/MapLegends/StyleBasedLegendByKey';

const StyleBasedLegendByKey = ({...props}) => {
	return <CommonStyleBasedLegendByKey {...props} />;
};

export default StyleBasedLegendByKey;
